var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWarning = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlSpace: "preserve",
    viewBox: "-380 292 30 30",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m-365 296.65-10.103 21.6h20.205zm0-4.65c.646 0 1.293.436 1.784 1.308l12.805 25.521c.981 1.744.147 3.171-1.854 3.171h-25.468c-2.001 0-2.835-1.427-1.854-3.171l12.805-25.521c.491-.872 1.137-1.308 1.784-1.308z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-375.103 318.25-365 296.647l10.103 21.603z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -365,
    cy: 314.5,
    r: 1.875,
    style: {
      fill: "#ffb000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-365 303.25c1.035 0 1.875.84 1.875 1.875l-.586 5.625h-2.579l-.586-5.625c0-1.035.84-1.875 1.875-1.875z",
    style: {
      fill: "#ffb000"
    }
  }));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWarning);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/warning.svg";